export default __webpack_public_path__ + "static/media/old.3a9e5c67.png";